export default __webpack_public_path__ + "static/media/1.7864f1f9.png";